if (!customElements.get('image-hotspots')) {
  class ImageHotspots extends HTMLElement {
    constructor() {
      super();
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
      this.handlers = [];
    }

    connectedCallback() {
      this.enableHover = this.dataset.enableHover === 'true';
      this.supportsHover = window.matchMedia('(hover: hover)').matches;
      this.spots = Array.from(this.querySelectorAll('[data-hotspot]'));

      if (!this.spots.length) return;

      this.spots.forEach((spot) => {
        const trigger = spot.querySelector('[data-hotspot-trigger]');
        if (!trigger) return;

        const onClick = (event) => {
          event.preventDefault();
          const isOpen = spot.classList.contains('is-active');
          this.closeAll();
          if (!isOpen) this.setSpotState(spot, true);
        };

        const onFocusIn = () => {
          this.closeAll(spot);
          this.setSpotState(spot, true);
        };

        const onFocusOut = (event) => {
          if (!spot.contains(event.relatedTarget)) this.setSpotState(spot, false);
        };

        trigger.addEventListener('click', onClick);
        spot.addEventListener('focusin', onFocusIn);
        spot.addEventListener('focusout', onFocusOut);

        const entry = {
          spot,
          trigger,
          onClick,
          onFocusIn,
          onFocusOut
        };

        if (this.enableHover && this.supportsHover) {
          entry.onMouseEnter = () => {
            this.closeAll(spot);
            this.setSpotState(spot, true);
          };
          entry.onMouseLeave = () => {
            this.setSpotState(spot, false);
          };
          spot.addEventListener('mouseenter', entry.onMouseEnter);
          spot.addEventListener('mouseleave', entry.onMouseLeave);
        }

        this.handlers.push(entry);
      });

      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onDocumentKeydown);
    }

    disconnectedCallback() {
      this.handlers.forEach((entry) => {
        entry.trigger.removeEventListener('click', entry.onClick);
        entry.spot.removeEventListener('focusin', entry.onFocusIn);
        entry.spot.removeEventListener('focusout', entry.onFocusOut);
        if (entry.onMouseEnter) entry.spot.removeEventListener('mouseenter', entry.onMouseEnter);
        if (entry.onMouseLeave) entry.spot.removeEventListener('mouseleave', entry.onMouseLeave);
      });

      this.handlers = [];
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onDocumentKeydown);
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.closeAll();
    }

    onDocumentKeydown(event) {
      if (event.key !== 'Escape') return;
      this.closeAll();
    }

    closeAll(exceptSpot = null) {
      this.spots.forEach((spot) => {
        if (exceptSpot && spot === exceptSpot) return;
        this.setSpotState(spot, false);
      });
    }

    setSpotState(spot, isOpen) {
      const trigger = spot.querySelector('[data-hotspot-trigger]');
      if (!trigger) return;
      spot.classList.toggle('is-active', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  customElements.define('image-hotspots', ImageHotspots);
}
